<script setup lang="ts">
const { title = "Laster..." } = defineProps<{
  title?: string
  restricted?: boolean
}>()

const productContent = useProductContentStore()
</script>

<template>
  <div
    class="flex size-full overflow-clip rounded-xl bg-platform-paper px-2 font-national2condensed text-black lg:px-24"
    :class="{
      'brightness-[85%]': restricted,
    }"
  >
    <div
      class="relative size-full flex-col bg-platform-paper p-8"
    >
      <h4
        class="text-md hidden pb-4 font-national2 font-extrabold uppercase text-darker lg:block lg:text-lg"
        v-text="productContent.activeSubject?.title"
      />
      <h3
        class="pb-6 font-national2condensed text-2xl font-medium lg:text-4xl xl:text-5xl"
        v-text="title"
      />
      <section
        class="flex w-full flex-col items-center justify-center gap-4 self-center rounded-lg bg-white p-4"
      >
        <div
          class="relative flex h-12 w-full items-center justify-start rounded-xl bg-green-60/40 p-4"
        >
          <UIcon
            name="circle-filled"
            class="scale-75 rounded-full bg-white p-1 text-green-100 outline outline-2"
          />
        </div>
        <div
          class="relative flex h-12 w-full items-center justify-start rounded-xl bg-platform-paper p-4"
        >
          <UIcon
            name="circle-hollow"
            class="rounded-full bg-white text-gray-600"
            size="lg"
          />
        </div>
        <div
          class="relative flex h-12 w-full items-center justify-start rounded-xl bg-platform-paper p-4"
        >
          <UIcon
            name="circle-hollow"
            class="rounded-full bg-white text-gray-600"
            size="lg"
          />
        </div>
      </section>
    </div>
  </div>
</template>
